import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const AssuranceCertifications = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Simple Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Link to="/" className="text-teal-600 hover:text-teal-700 font-semibold flex items-center cursor-pointer whitespace-nowrap">
            <i className="ri-arrow-left-line mr-2"></i>
            Retour à l'accueil
          </Link>
        </div>
      </header>

      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 text-center">
              Assurances & <strong className="text-teal-600">Certifications</strong>
            </h1>
            
            <div className="grid md:grid-cols-2 gap-8">
              {/* Assurances */}
              <div className="bg-white rounded-lg p-8 shadow-lg">
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-shield-check-line text-3xl text-teal-600"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">Assurances</h3>
                </div>
                
                <div className="space-y-6">
                  <div>
                    <h4 className="text-lg font-bold text-gray-900 mb-2 flex items-center">
                      <i className="ri-checkbox-circle-line text-teal-600 mr-2"></i>
                      Responsabilité Civile Professionnelle
                    </h4>
                    <p className="text-gray-700 leading-relaxed ml-7">
                      Couverture complète pour tous nos chantiers et interventions
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-bold text-gray-900 mb-2 flex items-center">
                      <i className="ri-checkbox-circle-line text-teal-600 mr-2"></i>
                      Assurance Décennale
                    </h4>
                    <p className="text-gray-700 leading-relaxed ml-7">
                      Garantie décennale sur tous nos travaux de menuiserie
                    </p>
                  </div>

                  <div className="bg-teal-50 border-l-4 border-teal-600 p-4 mt-6">
                    <p className="text-sm text-gray-700">
                      <strong>Assureur :</strong> Allianz France<br />
                      <strong>Numéro de police :</strong> Sur demande<br />
                      <strong>Validité :</strong> En cours
                    </p>
                  </div>
                </div>
              </div>

              {/* Certifications */}
              <div className="bg-white rounded-lg p-8 shadow-lg">
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-award-line text-3xl text-teal-600"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">Certifications</h3>
                </div>
                
                <div className="space-y-6">
                  <div>
                    <h4 className="text-lg font-bold text-gray-900 mb-2 flex items-center">
                      <i className="ri-checkbox-circle-line text-teal-600 mr-2"></i>
                      Certification RGE
                    </h4>
                    <p className="text-gray-700 leading-relaxed ml-7">
                      Reconnu Garant de l'Environnement pour les travaux d'économie d'énergie
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-bold text-gray-900 mb-2 flex items-center">
                      <i className="ri-checkbox-circle-line text-teal-600 mr-2"></i>
                      Qualibat
                    </h4>
                    <p className="text-gray-700 leading-relaxed ml-7">
                      Qualification professionnelle du bâtiment
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-bold text-gray-900 mb-2 flex items-center">
                      <i className="ri-checkbox-circle-line text-teal-600 mr-2"></i>
                      Cekal
                    </h4>
                    <p className="text-gray-700 leading-relaxed ml-7">
                      Certification de qualité pour les vitrages isolants
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-bold text-gray-900 mb-2 flex items-center">
                      <i className="ri-checkbox-circle-line text-teal-600 mr-2"></i>
                      Chambre des Métiers
                    </h4>
                    <p className="text-gray-700 leading-relaxed ml-7">
                      Immatriculation au répertoire des métiers
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Garanties */}
            <div className="bg-white rounded-lg p-8 shadow-lg mt-8">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-verified-badge-line text-3xl text-teal-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">Nos Garanties</h3>
              </div>
              
              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center p-6 bg-gray-50 rounded-lg">
                  <i className="ri-time-line text-4xl text-teal-600 mb-3"></i>
                  <h4 className="text-lg font-bold text-gray-900 mb-2">Garantie 2 ans</h4>
                  <p className="text-gray-700 text-sm">
                    Sur tous nos produits et installations
                  </p>
                </div>

                <div className="text-center p-6 bg-gray-50 rounded-lg">
                  <i className="ri-tools-line text-4xl text-teal-600 mb-3"></i>
                  <h4 className="text-lg font-bold text-gray-900 mb-2">SAV réactif</h4>
                  <p className="text-gray-700 text-sm">
                    Intervention sous 48h en cas de problème
                  </p>
                </div>

                <div className="text-center p-6 bg-gray-50 rounded-lg">
                  <i className="ri-customer-service-2-line text-4xl text-teal-600 mb-3"></i>
                  <h4 className="text-lg font-bold text-gray-900 mb-2">Suivi personnalisé</h4>
                  <p className="text-gray-700 text-sm">
                    Un interlocuteur dédié pour votre projet
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-teal-50 border-l-4 border-teal-600 p-6 mt-8">
              <h4 className="text-xl font-bold text-gray-900 mb-3">Demande d'attestations</h4>
              <p className="text-gray-700 leading-relaxed mb-2">
                Pour obtenir une copie de nos attestations d'assurance et certifications :
              </p>
              <p className="text-gray-700 leading-relaxed">
                <strong>Email :</strong> info@dfpro.fr<br />
                <strong>Téléphone :</strong> 04.65.84.88.50
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default AssuranceCertifications;
